<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ title }}</span>
      <v-tooltip right max-width="250px" class="mr-2" nudge-bottom="100">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" color="white" class="ml-2"
            >help_outline</v-icon
          >
        </template>
        <span>{{
          this.$store.state.app.config.messageConfig.rpInuToolTip
        }}</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn
        v-if="risk"
        outlined
        x-small
        color="white"
        class="rp-btn mr-2"
        :loading="editFlag !== 0 && editLocationMode !== 1"
        @click="collectionRisk"
      >
        <span>{{ text.update }}</span>
      </v-btn>
    </v-row>
    <template v-if="luList.length">
      <v-col class="com-pc-card-contents py-0">
        <v-list class="pa-0" v-for="(river, idx) in luList" :key="idx">
          <v-list-group no-action v-model="isExpand[idx]">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ river.riverName }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>{{ text.depthMax }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{
                  text.startTime
                }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{
                  text.continueTime
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-subtitle v-if="river.depthMax != null"
                  >{{ river.depthMax
                  }}{{ text.depthMaxUnit }}</v-list-item-subtitle
                >
                <v-list-item-subtitle v-else
                  >{{ text.noData
                  }}{{ text.depthMaxUnit }}</v-list-item-subtitle
                >
                <v-list-item-subtitle v-if="changeToDays(river.startTime) != 0"
                  >{{ changeToDays(river.startTime) }}{{ text.timeUnitDay
                  }}{{ changeToHours(river.startTime) }}{{ text.timeUnitHour
                  }}{{ changeToMinutes(river.startTime)
                  }}{{ text.timeUnitMin }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  v-else-if="changeToHours(river.startTime) != 0"
                  >{{ changeToHours(river.startTime) }}{{ text.timeUnitHour
                  }}{{ changeToMinutes(river.startTime)
                  }}{{ text.timeUnitMin }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  v-else-if="
                    changeToMinutes(river.startTime) != 0 ||
                      river.startTime == 0
                  "
                  >{{ changeToMinutes(river.startTime)
                  }}{{ text.timeUnitMin }}</v-list-item-subtitle
                >
                <v-list-item-subtitle v-else
                  >{{ text.noData }}{{ text.timeUnitMin }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  v-if="changeToDays(river.time0_5Continue) != 0"
                  >{{ changeToDays(river.time0_5Continue) }}{{ text.timeUnitDay
                  }}{{ changeToHours(river.time0_5Continue)
                  }}{{ text.timeUnitHour
                  }}{{ changeToMinutes(river.time0_5Continue)
                  }}{{ text.timeUnitMin }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  v-else-if="changeToHours(river.time0_5Continue) != 0"
                  >{{ changeToHours(river.time0_5Continue)
                  }}{{ text.timeUnitHour
                  }}{{ changeToMinutes(river.time0_5Continue)
                  }}{{ text.timeUnitMin }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  v-else-if="
                    changeToMinutes(river.time0_5Continue) != 0 ||
                      river.time0_5Continue == 0
                  "
                  >{{ changeToMinutes(river.time0_5Continue)
                  }}{{ text.timeUnitMin }}</v-list-item-subtitle
                >
                <v-list-item-subtitle v-else
                  >{{ text.noData }}{{ text.timeUnitMin }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <img
                  src="/kawabou/img/hanrei_hazard_map.png"
                  width="400"
                  height="400"
                  id="rp-lu-legend"
                />
                <img
                  src="/kawabou/img/hanrei_hazard_stage.svg"
                  width="400"
                  :height="computeLuHeight(idx)"
                  id="rp-lu-stage"
                />
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-divider></v-divider>
        </v-list>
      </v-col>
    </template>
    <template v-if="!luList.length">
      <v-col class="no-river">
        <v-btn
          v-if="!risk"
          outlined
          small
          color="success"
          class="rp-btn"
          :loading="editFlag !== 0 && editLocationMode !== 1"
          @click="collectionRisk"
        >
          <span>{{ text.point }}{{ point }}{{ text.collection }}</span>
        </v-btn>
        <span v-if="risk">{{
          this.$store.state.app.config.messageConfig.rpNoInu
        }}</span>
      </v-col>
    </template>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用登録地点情報画面 浸水想定カード
 * RpInundation.vue
 * @author LIS
 */
import WebStorage from "../../lib/webStorage.js";

export default {
  name: "rp-inundation",
  data() {
    return {
      /** 浸水情報一覧を取得 */
      luListData: [],
      /** リスク判定有無 */
      risk: false,
      /** 文字列リソース */
      text: {
        title: "の浸水想定",
        depthMax: "想定最大浸水深",
        startTime: "最短浸水開始時間",
        continueTime: "最大浸水継続時間",
        depthMaxUnit: " m",
        timeUnitMin: " 分",
        timeUnitHour: " 時間",
        timeUnitDay: " 日",
        noData: "--",
        height: "(標高",
        unit: "m)",
        point: "地点",
        collection: "の浸水リスクを判定する",
        update: "リスク再判定",
      },
      isExpand: [],
    };
  },
  props: {
    point: { type: Number, default: 0 },
  },
  mounted() {
    // 浸水情報一覧を取得
    this.readLuList();
  },
  beforeDestroy() {
    this.$store.commit("map/setSelectPointRiver", []);
  },
  computed: {
    title() {
      this.$log.debug(
        "[rp] WebStorage.getPointInfo" + "(" + this.point + ")" + "info.name"
      );
      let info = WebStorage.getPointInfo(this.point);
      // 地点が登録されているか判定
      if (info != null && info.pointIndex != null && info.name != null) {
        if (info.name != "") {
          return (
            info.name +
            this.text.height +
            info.centerHeight +
            this.text.unit +
            this.text.title
          );
        }
        return (
          "地点" +
          this.point +
          this.text.height +
          info.centerHeight +
          this.text.unit +
          this.text.title
        );
      }
      return this.$store.state.app.config.messageConfig.rpNoRegist;
    },
    /** 浸水情報一覧を取得 */
    luList() {
      this.$log.debug(
        "[rp] WebStorage.getPointInfo" + "(" + this.point + ")" + "luDatas"
      );
      return this.luListData;
    },
    /** 登録地点読み込み日時 */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
    /** 登録地編集モード [0:未編集, 1:地図選択, 2:登録確認] */
    editLocationMode: {
      get() {
        return this.$store.state.map.editLocationMode;
      },
    },
    /** 登録中フラグ */
    editFlag: {
      get() {
        return this.$store.state.map.editFlag;
      },
    },
  },
  methods: {
    changeToDays(time) {
      let days = 0;
      if (time != null) {
        days = Math.floor(time / 1440);
      }
      this.$log.debug("[RpLu] changeToDays(" + time + ") = " + days);
      return days;
    },
    changeToHours(time) {
      let hours = 0;
      if (time != null) {
        hours = Math.floor((time - this.changeToDays(time) * 1440) / 60);
      }
      this.$log.debug("[RpLu] changeToHours(" + time + ") = " + hours);
      return hours;
    },
    changeToMinutes(time) {
      let minutes = 0;
      if (time != null) {
        minutes =
          time - this.changeToDays(time) * 1440 - this.changeToHours(time) * 60;
      }
      this.$log.debug("[RpLu] changeToMinutes(" + time + ") = " + minutes);
      return minutes;
    },
    /** 凡例水位表示計算 */
    computeLuHeight(idx) {
      var height = 0;
      var svgHeight = 0;
      const svg10 = 400 * 0.83;
      const svg10_20 = 400 * 0.09;
      if (
        this.luList[idx].depthMax != null &&
        this.luList[idx].depthMax != undefined
      ) {
        if (this.luList[idx].depthMax <= 10) {
          svgHeight = (this.luList[idx].depthMax / 10) * svg10;
        } else {
          svgHeight =
            svg10 + ((this.luList[idx].depthMax - 10) / 10) * svg10_20;
        }

        if (svgHeight <= 400) {
          height = svgHeight;
        } else {
          height = 400;
        }
      }
      return height;
    },
    /** 選択浸水想定河川を設定 */
    setSetSelectPointRiver() {
      let riverList = [];
      // 表示中の浸水想定情報の河川番号をストアに格納
      for (let eCnt = 0; eCnt < this.isExpand.length; eCnt++) {
        if (
          this.isExpand[eCnt] &&
          this.luList[eCnt] &&
          this.luList[eCnt].rvrCnv
        ) {
          riverList = this.luList[eCnt].rvrCnv;
          // 先頭を優先する
          break;
        }
      }
      this.$store.commit("map/setSelectPointRiver", riverList);
    },
    /** リスク情報の収集 */
    collectionRisk() {
      this.$log.debug("[RpLu] collectionRisk()");

      // 確認ダイアログ
      this.$store.commit("viewConfig/setRiskFlg", 1);
    },
    /** webストレージ読み込み */
    readLuList() {
      // 浸水情報一覧を取得
      let point = WebStorage.getPointInfo(this.point);
      let list = point.luDatas;
      list.sort(function(a, b) {
        if (a.depthMax == undefined || a.depthMax == null) {
          return 1;
        } else if (b.depthMax == undefined || b.depthMax == null) {
          return -1;
        } else if (a.depthMax < b.depthMax) {
          return 1;
        } else {
          return -1;
        }
      });
      this.luListData = list;
      this.risk = point.risk;
    },
  },
  watch: {
    // 浸水想定情報の開閉を監視
    isExpand() {
      this.setSetSelectPointRiver();
    },
    // 選択登録地点を監視
    point() {
      // 浸水情報一覧を取得
      this.readLuList();
      this.setSetSelectPointRiver();
    },
    // webストレージ編集日時更新を監視
    editWebStorageDate() {
      // 浸水情報一覧を取得
      this.readLuList();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.no-river {
  font-size: middle;
}
#rp-lu-legend {
  bottom: 12px;
  margin: 0px;
}
#rp-lu-stage {
  position: absolute;
  bottom: 12px;
  opacity: 0.6;
}
.rp-btn {
  font-size: 0.9rem;
}
</style>
